import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import TextField from '../../../text-field'

const ContainerElement = styled.div`
  position: relative;
`

const OptionsListElement = styled.ul`
  position: absolute;
  top: 105%;
  left: 0;
  width: 100%;
  max-height: 11.25rem;
  margin: 0;
  padding: 0 !important;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  overflow-y: auto;

  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  z-index: 1;
`

const OptionItemTextElement = styled.span``

const OptionItemWrapperElement = styled.li`
  padding: 8px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#f1f1f1' : '#fff')};

  &[disabled] {
    cursor: default;
    color: lightgray;
  }
`

const HighlightedTextElement = styled.span`
  color: #2e8ab8;
  font-weight: bold;
`

const getHighlightedText = (text, highlight) => {
  if (!highlight) return text

  const regex = new RegExp(`(${highlight})`, 'gi')
  const parts = text.split(regex)

  return parts.map((part, index) =>
    regex.test(part) ? (
      <HighlightedTextElement key={index}>{part}</HighlightedTextElement>
    ) : (
      part
    )
  )
}

const Autocomplete = ({ options, selectedOptionId, setSelectedOptionId }) => {
  const [inputValue, setInputValue] = useState('')
  const [filteredOptions, setFilteredOptions] = useState(options)

  const [showOptions, setShowOptions] = useState(false)
  const [focusedOptionIndex, setFocusedOptionIndex] = useState(-1)

  const optionsRefs = useRef([])

  const handleChange = (e) => {
    const newValue = selectedOptionId ? '' : e.target.value

    const newOptions = options.filter((option) =>
      option.documentTitle.toLowerCase().includes(newValue.toLowerCase())
    )

    setInputValue(newValue)
    setShowOptions(true)
    setFilteredOptions(newOptions)
    setFocusedOptionIndex(-1)
    if (!newValue) setSelectedOptionId(null)
  }

  const handleTargetSelect = (documentId) => {
    const { entityName, section, documentTitle } = options.find(
      (option) => option.documentId === documentId
    )

    setSelectedOptionId(documentId)
    setInputValue(`${entityName} / ${section} / ${documentTitle}`)
    setShowOptions(false)
    setFocusedOptionIndex(-1)
  }

  const handleFocusedOptionIndexChange = (diff) => {
    const maxIndex = filteredOptions.length - 1
    if (maxIndex < 0) return

    let newIndex = focusedOptionIndex + diff

    if (newIndex < 0) newIndex = maxIndex
    else if (newIndex > maxIndex) newIndex = 0

    setFocusedOptionIndex(newIndex)

    optionsRefs.current[newIndex].scrollIntoView({
      block: 'nearest',
    })
  }

  const handleKeyDown = (e) => {
    const pressedKey = e.key

    if (pressedKey === 'Escape') setShowOptions(false)

    if (pressedKey === 'Enter' && focusedOptionIndex >= 0) {
      e.preventDefault()
      handleTargetSelect(filteredOptions[focusedOptionIndex].documentId)
    }

    if (['ArrowDown', 'ArrowUp'].includes(pressedKey)) {
      e.preventDefault()
      if (!showOptions) setShowOptions(true)
      else handleFocusedOptionIndexChange(pressedKey === 'ArrowDown' ? 1 : -1)
    }
  }

  const handleBlur = () => {
    setShowOptions(false)
    if (!selectedOptionId) setInputValue('')
  }

  return (
    <ContainerElement>
      <TextField
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={() => setShowOptions(true)}
        onKeyDown={handleKeyDown}
        placeholder="Search document bucket list"
        autocomplete="off"
      />
      {showOptions && (
        <OptionsListElement>
          {filteredOptions.length > 0 ? (
            filteredOptions.map(
              ({ documentId, entityName, section, documentTitle }, index) => (
                <OptionItemWrapperElement
                  key={documentId}
                  isSelected={index === focusedOptionIndex}
                  innerRef={(el) => (optionsRefs.current[index] = el)}
                  onMouseDown={() => handleTargetSelect(documentId)}
                  onMouseOver={() => setFocusedOptionIndex(index)}
                >
                  <OptionItemTextElement>
                    {entityName} / {section} /{' '}
                    {getHighlightedText(documentTitle, inputValue)}
                  </OptionItemTextElement>
                </OptionItemWrapperElement>
              )
            )
          ) : (
            <OptionItemWrapperElement disabled>
              <OptionItemTextElement>No results</OptionItemTextElement>
            </OptionItemWrapperElement>
          )}
        </OptionsListElement>
      )}
    </ContainerElement>
  )
}

export default Autocomplete
